<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave única del impuesto"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="200"
      helpText="Nombre del impuesto"
    />
    
    <FormField
      id="Tasa"
      label="Tasa (%)"
      type="number"
      v-model="formData.Tasa"
      :required="true"
      step="0.01"
      min="0"
      max="100"
      helpText="Tasa del impuesto en porcentaje"
    />
    
    <FormField
      id="Tipo"
      label="Tipo"
      type="select"
      v-model="formData.Tipo"
      :required="true"
      :options="tipoOptions"
      helpText="Tipo de impuesto"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave en el sistema ERP"
    />
    
    <FormField
      id="EsActivo"
      label="Es Activo"
      type="checkbox"
      v-model="formData.EsActivo"
      helpText="Indica si el impuesto está activo"
    />
    
    <FormField
      id="Clave2"
      label="Clave 2"
      type="text"
      v-model="formData.Clave2"
      :maxlength="50"
      helpText="Clave secundaria"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatImpuestoForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    impuesto: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: null,
        Nombre: '',
        Tasa: 0,
        Tipo: '',
        ClaveErp: '',
        EsActivo: true,
        Clave2: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.impuesto },
      tipoOptions: [
        { value: 'I', label: 'Impuesto' },
        { value: 'R', label: 'Retención' },
        { value: 'T', label: 'Traslado' },
        { value: 'O', label: 'Otro' }
      ]
    };
  },
  watch: {
    impuesto: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
